import {
  ThemeUICSSObject,
  getColorsByPath,
  responsive,
  spacing,
} from '@apia/theme';
/* IMPORT HERE */
export const gridSpan = responsive({
  0: 'span 1',
  3: 'span 2',
  4: 'span 4',
});
const traceability: ThemeUICSSObject = {
  fieldset: {
    display: 'grid',
    gridTemplateColumns: responsive({
      0: '1fr',
      2: 'repeat(2, 1fr)',
      4: 'repeat(4, 1fr)',
    }),
    gap: spacing(4),
    p: spacing(7),
    border: 'none',
    ...getColorsByPath('tab'),

    '.dataTable': {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },

    '& label': {
      display: 'block',
    },
  },
};

export default traceability;
